import { atom } from 'jotai/index';
import { atomWithStorage, createJSONStorage } from 'jotai/utils';
import type { AnalysisEntityCacheType } from './type';
import { StorageKeys } from '../../lib/constants';
import { allowCommunityHistoryView } from '../subscription/atoms';
import * as cookies from '../../lib/cookies';
import { isSameAnalysisEntity } from './utils';

const defaultEntity: AnalysisEntityCacheType = cookies.getCookie(
  StorageKeys.ActiveAnalysisEntityStorage
);

const entityCacheStorage = createJSONStorage<AnalysisEntityCacheType>(() => {
  return {
    getItem: cookies.getCookie,
    setItem: cookies.setCookie,
    removeItem: cookies.removeCookie,
  };
});

export const cachedEntityAtom = atomWithStorage<AnalysisEntityCacheType>(
  StorageKeys.ActiveAnalysisEntityStorage,
  defaultEntity,
  entityCacheStorage
);

const setCachedEntityAtom = atom(
  null,
  (get, set, community: AnalysisEntityCacheType | null) => {
    set(cachedEntityAtom, community);
  }
);

export const activeEntityAtom = atom<AnalysisEntityCacheType | null>(null);

export const getActiveEntityAtom = atom((get) => {
  const cachedEntity = get(cachedEntityAtom);
  const activeEntity = get(activeEntityAtom);

  return activeEntity ?? cachedEntity;
});

export const setActiveEntityAtomValue = atom(
  null,
  (get, set, analysisEntity: AnalysisEntityCacheType) => {
    const currentEntity = get(activeEntityAtom);

    if (isSameAnalysisEntity(currentEntity, analysisEntity)) return;

    set(activeEntityAtom, analysisEntity);
    set(setCachedEntityAtom, analysisEntity);
    set(allowCommunityHistoryView, false);
  }
);

export const searchQueryAtom = atom<string>('');

export const isCommunityDialogOpenAtom = atom<boolean>(false);
